import { render, staticRenderFns } from "./TagSetting.vue?vue&type=template&id=086ce5b5"
import script from "./TagSetting.vue?vue&type=script&lang=js"
export * from "./TagSetting.vue?vue&type=script&lang=js"
import style0 from "./TagSetting.vue?vue&type=style&index=0&id=086ce5b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports